import { useMutation, useQuery } from '@apollo/client';
import React from 'react';
import { UPDATE_PROFILE } from '../../../graphql/profile/mutations';
import { GET_AVATAR } from '../../../graphql/profile/queries';
import { UpdateProfileCommandInput } from '../../../graphql/__generated__/graphql';
import EditableAvatar from './EditableAvatar';
import { IEditableAvatarFormProps } from './IEditableAvatarFormProps';

export const EditableAvatarContainer: React.FC = () => {
    const [updateProfile] = useMutation(UPDATE_PROFILE);
    const { data, error, loading, refetch } = useQuery(GET_AVATAR);

    const handleUpdate = async (form: IEditableAvatarFormProps) => {
        if (error) {
            throw error;
        }

        await updateProfile({
            variables: {
                profile: {
                    id: data.avatar.id,
                    avatar: form.imageData,
                    removeAvatar: form.imageData === null,
                } as UpdateProfileCommandInput,
            },
        });

        await refetch();
    };

    return <EditableAvatar data={data} loading={loading} error={error} onUpdate={handleUpdate} />;
};
